exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "::-ms-clear {\n    display: none;\n}\n\n.form-control-clear {\n    z-index: 10;\n    pointer-events: auto;\n    cursor: pointer;\n}", ""]);

